/* @flow */
/* eslint react/no-array-index-key: "off" */

import * as React from 'react';
import glamorous from 'glamorous';
import { Link } from 'react-router-dom';
import { isString } from 'lodash';
import ImageCarousel from 'app/components/commons/ImageCarousel';
import Responsive from 'app/components/responsive/Responsive';

type Props = {
  images: Array<*>,
  isSignedIn: boolean,
};

const Image = glamorous.img({
  height: 'auto',
  width: '100%',
});

function Button({
  link,
  external,
  children,
}: {
  link: string,
  external: boolean,
  children: React.Node,
}) {
  if (external) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  return <Link to={link}>{children}</Link>;
}

function PromoBanner({ images = [], isSignedIn }: Props) {
  return (
    <div>
      <Responsive tabletPortrait desktop>
        {isLargeScreen => (
          <ImageCarousel height={isLargeScreen ? 111 : 60} width={isLargeScreen ? 1100 : 414}>
            {images.map((image, i) => {
              const src = isLargeScreen ? image.desktopSrc : image.mobileSrc;
              return image.link ? (
                <Button
                  link={!!image.linkSignedIn && isSignedIn ? image.linkSignedIn : image.link}
                  external={isString(image.link) && image.link.search(/http/) !== -1}
                  key={i}
                >
                  <Image alt={image.alt} src={src} />
                </Button>
              ) : (
                <Image key={i} alt={image.alt} src={src} />
              );
            })}
          </ImageCarousel>
        )}
      </Responsive>
    </div>
  );
}

export default PromoBanner;
